<template>
<Encabeza></Encabeza>
<v-card class="mx-auto my-8" elevation="16" max-width="450">
    <v-card-title class="dynamic-title text-truncate text-xs-center text-md-center">REGISTRO MASIVO DE DATOS</v-card-title>
    <v-divider></v-divider>
    <v-card-text>
        <div>
            <v-btn class="ma-2" color="success" variant="outlined" @click="openDialogImportData">IMPORTAR<v-icon color="green" end icon="mdi-plus-box-multiple"></v-icon>
            </v-btn>
        </div>
        <div>
            <v-btn class="mr-0 text-right" :class="{ 'download-button': true }" color="success" dark @click="downloadExcel"> DESCARGAR PLANTILLA<v-icon color="white" end icon="mdi-file-excel"></v-icon>
            </v-btn>
        </div>
    </v-card-text>
</v-card>

<!-- Opcional: Otro v-card para separar visualmente -->
<!-- <v-card>
      Contenido opcional aquí
    </v-card> -->

<v-dialog v-model="dialog_import" persistent transition="dialog-bottom-transition" scrollable width="600px" max-height="600px">
    <DialogImportPersonalMilitar :p_current_sucursal="current_sucursal" @isCloseDialogImportData="closeDialogImportData" @isInitData="initData" />
</v-dialog>
</template>

  
<style>
.download-button {
    font-size: 11px;
    margin: 10px;
    border: 1px solid #4CAF50;
    background-color: #4CAF50;
    color: white;
    padding: 5px 10px;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color 0.3s;
}

.download-button:hover {
    background-color: #45a049;
}

.dynamic-title {
    font-size: 16px;
    color: #4CAF50;
    font-weight: bold;
    text-align: center;
}
</style>

  
<script>
import Encabeza from '@/components/EncabezadoPage.vue';
import {
    defineComponent
} from 'vue';
import DialogImportPersonalMilitar from '@/components/registro/DialogImportPersonalMilitar.vue';

export default defineComponent({
    components: {
        Encabeza,
        DialogImportPersonalMilitar,
    },
    data() {
        const dialog_import = false;
        return {
            dialog_import,
        };
    },
    methods: {
        async openDialogImportData() {
            this.dialog_import = true;
        },
        closeDialogImportData() {
            this.dialog_import = false;
        },
        downloadExcel() {
            const excelUrl = require('@/assets/plantillamilitar.xlsx');
            const link = document.createElement('a');
            link.href = excelUrl.default;
            link.setAttribute('download', 'plantillamilitar.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    },
});
</script>
